import { Params } from '@angular/router';

import { Action } from '@ngrx/store';

export enum FilterActionTypes {
    SetConceptsFilter = '[Filter] SetConceptsFilter',
    SetProcessingListFilter = '[Filter] SetProcessingListFilter',
    SetEvaluateFilter = '[Filter] SetEvaluateFilter',
    SetPublishedFilter = '[Filter] SetPublishedFilter',
    UnsetFilters = '[Filter] UnsetFilters'
}

export class SetConceptsFilter implements Action {
    type: FilterActionTypes.SetConceptsFilter = FilterActionTypes.SetConceptsFilter;
    constructor(public payload: Params) {}
}

export class SetEvaluateFilter implements Action {
    type: FilterActionTypes.SetEvaluateFilter = FilterActionTypes.SetEvaluateFilter;
    constructor(public payload: Params) {}
}

export class SetPublishedFilter implements Action {
    type: FilterActionTypes.SetPublishedFilter = FilterActionTypes.SetPublishedFilter;
    constructor(public payload: Params) {}
}

export class SetProcessingListFilter implements Action {
    type: FilterActionTypes.SetProcessingListFilter = FilterActionTypes.SetProcessingListFilter;
    constructor(public payload: Params) {}
}

export class UnsetFilters implements Action {
    readonly type: FilterActionTypes.UnsetFilters = FilterActionTypes.UnsetFilters;
}

export type FilterActions =
    | SetProcessingListFilter
    | SetConceptsFilter
    | SetEvaluateFilter
    | SetPublishedFilter
    | UnsetFilters;
